import { render, staticRenderFns } from "./Fiscal-page.vue?vue&type=template&id=0de23240&"
import script from "./Fiscal-page.vue?vue&type=script&lang=js&"
export * from "./Fiscal-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports